module.exports = __webpack_public_path__ + "niger.svg?6ef02e94e50e13f82791733b7b1bec16";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/niger.svg
// module id = 248
// module chunks = 10